import React, { useEffect } from 'react';

export default function ModalShell({
  open,
  onClose = () => {},
  title = '',
  /** width puede ser number (px) o string (ej. "70vw") */
  width = 800,
  /** maxWidth delimita el ancho respecto al viewport */
  maxWidth = '96vw',
  /** altura del contenido: el body scrollea, no la página */
  maxBodyHeight = '80vh',
  /** si false, no cierra al hacer clic fuera */
  closeOnBackdrop = true,
  footer = null,
  bodyStyle = {},
  children,
  /** centrado vertical: "center" | "top" */
  verticalAlign = 'top',
}) {
  // cerrar con ESC y bloquear scroll del body
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);

    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  const stop = (e) => e.stopPropagation();
  const onBackdrop = () => { if (closeOnBackdrop) onClose(); };
  const px = typeof width === 'number' ? `${width}px` : width;

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onBackdrop}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(0,0,0,.35)',
        display: 'flex',
        alignItems: verticalAlign === 'center' ? 'center' : 'flex-start',
        justifyContent: 'center',
        padding: verticalAlign === 'center' ? '24px' : '40px 16px'
      }}
    >
      <div
        onClick={stop}
        style={{
          width: '100%',
          maxWidth,      // tope por viewport
          // ancho deseado (siempre respetando maxWidth)
          ...(px ? { width: px } : {}),
          background: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.08)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 14px', borderBottom: '1px solid #e5e7eb'
        }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button className="btn" onClick={onClose} aria-label="Cerrar">Cerrar</button>
        </div>

        {/* Body (scrollea dentro del modal) */}
        <div
          style={{
            padding: 12,
            overflow: 'auto',
            maxHeight: maxBodyHeight,
            ...bodyStyle
          }}
        >
          {children}
        </div>

        {/* Footer (se renderiza sólo si hay contenido) */}
        {footer != null && (
          <div style={{ padding: 12, borderTop: '1px solid #e5e7eb' }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
